import React from 'react';
import { connect } from 'react-redux';
import $ from 'jquery';
import { List } from 'immutable';
import { Row, Col, Button } from 'react-bootstrap';
import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer, LabelList,
  XAxis, YAxis, CartesianGrid, Rectangle, Bar, Line, ComposedChart } from 'recharts';
import { MainComponentBox, reportFormatter, reportFormatter2, millionFormatter, paintColorSaleBlue, paintColorPurchaseBlue }
  from '@/util/util.jsx';
import { formatNumber } from '../deals/elements/BaseElement';
import {profitabilityLoad, totalProfitByProduct, updateDate} from './store/Profitability.store';
import momentLocalizer from 'react-widgets-moment';
import moment from 'moment';
import './reports.less';
import { fixDate } from '../../../util/util';
import FromToDatePickers from '../../form/FromToDateHorizontalPickers';
import { paintColorAcid } from '@/util/util';
moment.locale('en');
momentLocalizer();

const RADIAN = Math.PI / 180;

// eslint-disable-next-line
export const percentLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, percent }) => {
  const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
  const x = cx + radius * Math.cos(-midAngle * RADIAN);
  const y = cy + radius * Math.sin(-midAngle * RADIAN);

  return (
    <text x={x} y={y} fill="black" textAnchor="middle" dominantBaseline="central">
      {`${percent * 100 < 5 ? '' : `${(percent * 100).toFixed(0)}%`}`}
    </text>
  );
};

export const getChartColor = (id, isSale) => {
  if (isSale) {
    return paintColorSaleBlue(id);
  }
  if (isSale === false) {
    return paintColorPurchaseBlue(id);
  }
  return paintColorAcid(id);
};

export function emptyChartDataWrapper(profitData, height, chart) {
  if (!profitData.length) {
    return (<div
      style={{ display: 'flex',
        width: '100%',
        height: `${height}px`,
        alignItems: 'center',
        justifyContent: 'center' }}
    >
      No data available
    </div>);
  }
  return chart;
}

export const pieLegendWrapper = (chart, data, isSale, isCurrency = false) => {
  const LEGEND_SQUARE_SIZE = '30px';
  const totalSum = data.filter(e => e.value > 0).reduce((sum, d) => sum + d.value, 0);
  let calcError = 0;
  const legend = [];
  const negativeData = data.filter(e => e.value < 0);
  const positiveData = data.filter(e => e.value > 0);
  const legendItem = (entry, isPositive) => {
    const currentPercent = (entry.value / totalSum) * 100 - calcError;
    const roundedPercent = Math.round(currentPercent);
    calcError = roundedPercent - currentPercent;
    const color = getChartColor(entry.id, isSale);
    return (
      <Col
        xs={12}
        style={{
          margin: '2px',
          display: 'flex',
          textAlign: 'left',
          padding: 0,
          alignItems: 'center',
        }}
      >
        <div
          style={{
            width: LEGEND_SQUARE_SIZE,
            minWidth: LEGEND_SQUARE_SIZE,
            height: LEGEND_SQUARE_SIZE,
            background: isPositive ? color : '#fff',
            border: isPositive ? '' : `1px dotted ${color}`,
          }}
        />
        <div
          style={{
            fontSize: '12px',
            paddingLeft: '5px',
          }}
        >
          {entry.name}<br />
          <b>{`${isPositive ? `${roundedPercent}%` : ''}`} </b>
          {`${isCurrency ? "$" : ""}${formatNumber(entry.value, '0,0')}`}
        </div>
      </Col>);
  };
  positiveData.forEach((entry) => {
    legend.push(legendItem(entry, true));
  });
  negativeData.forEach((entry) => {
    legend.push(legendItem(entry, false));
  });
  return (
    <Row style={{ display: 'flex', alignItems: 'center' }}>
      <Col xs={8}>
        {chart}
      </Col>
      <Col xs={4}>
        <Row>
          {legend}
        </Row>
      </Col>
    </Row>);
};

export const resetChartLines = () => {
  (window.chartLines || []).forEach((line) => {
    $(window).off('resize');
    if (line) {
      const lineParent = line.parentNode;
      if (lineParent) {
        lineParent.removeChild(line);
      }
    }
  });
  window.chartLines = [];
};

export const highlightChartZero = (chartContainerId, zeroValue = '0') => {
  function makeSVG(tag, attrs) {
    // eslint-disable-next-line
    const el = document.createElementNS('http://www.w3.org/2000/svg', tag);
    // eslint-disable-next-line
    for (const k in attrs) { el.setAttribute(k, attrs[k]); }
    return el;
  }

  const func = () =>
    new Promise((resolve, reject) => {
      setTimeout(() => {
        const zeroGElement = $(`#${chartContainerId}`)
          .find('svg.recharts-surface g.yAxis g.recharts-cartesian-axis-ticks ' +
            'g.recharts-layer').filter((idx, node) => $(node).children('text').text() == zeroValue);
        if (zeroGElement.length) {
          resolve(zeroGElement[0]);
        } else {
          // if ($(`#${chartContainerId}`).find('svg.recharts-surface').length) {
          reject(true);
          // } else {
          //   reject(false);
          // }
        }
      }, 1000);
    }).then(
      (zeroGElement) => {
        const highlightLineAttrs = {};
        let highlightContainer = null;
        const lineNode = $(zeroGElement).children('line');
        if (lineNode.length) {
          const xAxisLines = $(`#${chartContainerId}`).find('svg.recharts-surface g.xAxis line');
          if (xAxisLines.length) {
            const chartLineWidth = $(xAxisLines[0]).attr('x2');
            highlightContainer = lineNode.parent()[0];
            highlightLineAttrs.x1 = lineNode.attr('x1');
            highlightLineAttrs.y1 = lineNode.attr('y1');
            highlightLineAttrs.x2 = chartLineWidth;
            highlightLineAttrs.y2 = lineNode.attr('y2');
          }
          if (Object.keys(highlightLineAttrs).length) {
            $(window).resize(() => {
              $(highlightContainer).find('#zeroLine')[0].setAttribute('x2', xAxisLines.attr('x2'));
            });
            const svgLine = makeSVG('line', {
              id: 'zeroLine',
              'stroke-width': 3,
              width: 60,
              height: 345,
              x: 0,
              y: 0,
              stroke: '#bababa',
              fill: 'none',
              x1: parseInt(highlightLineAttrs.x1, 10) + 6,
              y1: highlightLineAttrs.y1,
              x2: highlightLineAttrs.x2,
              y2: highlightLineAttrs.y2,
            });
            highlightContainer.appendChild(svgLine);
            const chartLines = window.chartLines || [];
            chartLines.push(svgLine);
            window.chartLines = chartLines;
          }
        }
      },
      (repeat) => repeat ? func() : null, // eslint-disable-line
    );
  return func();
};

// eslint-disable-next-line
const CustomColorBar = props => <Rectangle
  {...props}
  fill={getChartColor(props.id, props.isSale)}
/>;
CustomColorBar.propTypes = {
  isSale: React.propTypes.bool,
  id: React.propTypes.number,
};

export const CustomizedAxisTick = props =>
  <g transform={`translate(${props.x},${props.y})`}>
    <text
      x={0} y={0} dy={16} textAnchor="end" fill="#666"
      transform="rotate(-45)"
    >{props.payload && props.payload.value || ''}</text>
  </g>;
CustomizedAxisTick.propTypes = {
  payload: React.PropTypes.object,
  x: React.PropTypes.number,
  y: React.PropTypes.number,
};

class ProfitabilityReportClass extends React.Component {
  constructor(props) {
    super(props);
    this.generateReport = this.generateReport.bind(this);
  }

  componentWillMount() {
    this.generateReport();
  }

  componentDidMount() {
    $().ready(() => {
      highlightChartZero('destinationProfit');
      highlightChartZero('originProfit');
      highlightChartZero('destinationCountryProfit');
      highlightChartZero('originCountryProfit');
    });
  }

  componentWillUnmount() {
    resetChartLines();
  }

  totalProfitChart(profitDataArg = [], isSale) {
    const height = 400;
    const profitData = profitDataArg.sort((a, b) => (a.value < b.value ? 1 : -1));
    const chartData = profitData
      .filter(e => e.value > 0);
    return emptyChartDataWrapper(profitData, height,
      pieLegendWrapper(
        <ResponsiveContainer width="100%" height={height}>
          <PieChart>
            <Pie
              isAnimationActive={false}
              data={chartData}
              outerRadius={160}
              innerRadius={80}
              startAngle={180}
              endAngle={540}
              // labelLine={false}
              // label={percentLabel}
              paddingAngle="0"
              fill="#8884d8"
            >
              {
                chartData.reverse().map(entry => <Cell
                  fill={getChartColor(entry.id, isSale)}
                />)
              }
            </Pie>
            <Tooltip formatter={v => formatNumber(v, '$0,0.[00]')} />
          </PieChart>
        </ResponsiveContainer>, profitData, isSale, true),
    );
  }

  avgPerTonProfitChart(profitData, verticalXLabels = false, isSale, withTotal, totalLabelFormatter = reportFormatter) {
    const xAxis = verticalXLabels ?
      (<XAxis
        dataKey="name" interval={0} tick={<CustomizedAxisTick />} tickMargin={0} minTickGap={0}
        tickSize={1} height={130}
      />) :
      <XAxis dataKey="name" />;
    const labelFormatter = (val) => {
      if (val == 0) {
        return '';
      }
      return formatNumber(val, '$0,0.[00]');
    };
    const height = 400;
    return emptyChartDataWrapper(profitData, height,
      <ResponsiveContainer width="100%" height={height}>
        <ComposedChart
          data={profitData}
          barGap={0}
          margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
        >
          {xAxis}
          <YAxis yAxisId="perTonProfit" tickFormatter={reportFormatter} />
          <YAxis yAxisId="totalProfit" tickFormatter={reportFormatter} orientation="right" />
          <CartesianGrid strokeDasharray="3 3" vertical={false}/>
          <Tooltip formatter={labelFormatter} />
          <Bar
            yAxisId="perTonProfit"
            dataKey="avg per ton"
            stackId="a"
            barSize={15}
            fill={isSale ? 'var(--reports-sale-bar)' : 'var(--reports-purchase-bar)'}
            shape={<CustomColorBar isSale={isSale} />}
            isAnimationActive={false}
          >
             <LabelList
              dataKey="avg per ton"
              position="top"
              fill="black"
              formatter={reportFormatter}
              angle={verticalXLabels && '-45'}
             />
          </Bar>
          { withTotal &&
            <Bar
              yAxisId="totalProfit"
              dataKey="avg total"
              stackId="b"
              barSize={15}
              fill={isSale ? 'var(--reports-sale-total-bar)' : 'var(--reports-purchase-total-bar)'}
              isAnimationActive={false}
            >
              <LabelList
                dataKey="avg total"
                position="top"
                fill="black"
                formatter={totalLabelFormatter}
                angle={verticalXLabels && '-45'}
              />
            </Bar>
          }
          <Line
            isAnimationActive={false}
            yAxisId="profit"
            type="monotone"
            dataKey="Profit"
            fill={!isSale ? 'var(--reports-sale-bar)' : 'var(--reports-purchase-bar)'}
            strokeWidth="4"
            dot={{ strokeWidth: 3, fill: 'white', r: 6 }}
          />
        </ComposedChart>
      </ResponsiveContainer>);
  }

  destinationProfitChart(profitData, verticalXLabels = false, isSale) {
    const xAxis = verticalXLabels ?
      (<XAxis
        dataKey="name" interval={0} tick={<CustomizedAxisTick />} tickMargin={0} minTickGap={0}
        tickSize={1} height={130}
      />) :
      <XAxis dataKey="name" />;
    const labelFormatter = (val) => {
      if (val == 0) {
        return '';
      }
      return formatNumber(val, '$0,0.[00]');
    };
    const height = 400;
    return emptyChartDataWrapper(profitData, height,
      <ResponsiveContainer width="100%" height={height}>
        <ComposedChart
          data={profitData}
          barGap={0}
          margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
        >
          {xAxis}
          <YAxis yAxisId="perTonProfit" tickFormatter={reportFormatter} />
          <YAxis yAxisId="totalProfit" tickFormatter={millionFormatter} orientation="right" />
          <CartesianGrid strokeDasharray="3 3" vertical={false} />
          <Tooltip formatter={labelFormatter} />
          <Bar
            yAxisId="perTonProfit"
            dataKey="Average PMT"
            stackId="a"
            barSize={15}
            fill={isSale ? 'var(--reports-sale-bar)' : 'var(--reports-purchase-bar)'}
            shape={<CustomColorBar isSale={isSale} />}
            isAnimationActive={false}
          >
            <LabelList
              dataKey="Average PMT"
              position="top"
              fill="black"
              formatter={reportFormatter}
              angle={verticalXLabels && '-45'}
            />
          </Bar>
          <Bar
            yAxisId="totalProfit"
            dataKey="Total"
            stackId="b"
            barSize={15}
            fill={isSale ? 'var(--reports-sale-total-bar)' : 'var(--reports-purchase-total-bar)'}
            isAnimationActive={false}
          >
            <LabelList
              dataKey="Total"
              position="top"
              fill="black"
              formatter={millionFormatter}
              angle={verticalXLabels && '-45'}
            />
          </Bar>
          <Line
            isAnimationActive={false}
            yAxisId="profit"
            type="monotone"
            dataKey="Profit"
            fill={!isSale ? 'var(--reports-sale-bar)' : 'var(--reports-purchase-bar)'}
            strokeWidth="4"
            dot={{ strokeWidth: 3, fill: 'white', r: 6 }}
          />
        </ComposedChart>
      </ResponsiveContainer>);
  }

  totalChart(profitDataArg = [], isSale) {
    const height = 400;
    const profitData = profitDataArg.sort((a, b) => (a.value < b.value ? 1 : -1));
    const chartData = profitData.filter(e => e.value > 0);
    return emptyChartDataWrapper(profitData, height,
      pieLegendWrapper(
        <ResponsiveContainer width="100%" height={height}>
          <PieChart>
            <Pie
              isAnimationActive={false}
              data={chartData}
              outerRadius={160}
              innerRadius={80}
              startAngle={180}
              endAngle={540}
              // labelLine={false}
              // label={percentLabel}
              paddingAngle="0"
            >
              {
                chartData.reverse().map(entry => <Cell
                  fill={getChartColor(entry.id, isSale)}
                />)
              }
            </Pie>
            <Tooltip formatter={v => formatNumber(v, '0,0')} />
          </PieChart>
        </ResponsiveContainer>, profitData, isSale, true));
  }

  generateReport(dateFrom = this.props.dateFrom, dateTo = this.props.dateTo) {
    resetChartLines();
    this.props.profitabilityLoad(dateFrom, dateTo);
    this.props.totalProfitByProduct('sale', dateFrom, dateTo);
    highlightChartZero('destinationProfit');
    highlightChartZero('originProfit');
    highlightChartZero('destinationCountryProfit');
    highlightChartZero('originCountryProfit');
  }

  caption(text) {
    return <div style={{ fontSize: 14, fontWeight: 'bold', marginTop: 5 }} >{text}</div>;
  }

  render() {
    const { dateFrom, dateTo } = this.props;
    return (
      <MainComponentBox>
        <Row>
          <Col md={12} style={{ textAlign: 'center' }}>
            <div
              style={{ display: 'inline-block',
                marginBottom: '-14px',
                width: '350px',
                textAlign: 'left',
                paddingRight: '15px' }}
            >
              <FromToDatePickers
                bindSelect={false}
                labelStyle={{ display: 'none' }}
                labelChildStyle={{ width: '100%', padding: 0 }}
                defaultValueFrom={dateFrom}
                defaultValueTo={dateTo}
                onChangeFrom={(val) => {
                  this.props.updateDate(fixDate(val), dateTo);
                }}
                onChangeTo={(val) => {
                  this.props.updateDate(dateFrom, fixDate(val));
                }}
              />
            </div>
            <Button
              bsStyle="primary"
              className={'dates-apply-button'}
              onClick={() => this.generateReport()}
            >
              Generate
            </Button>
          </Col>
        </Row>
        <Row className={'single-row-report-panels'}>
          <Col md={6}>
            <Row className={'report-panel'}>
              <Col xs={12} className={'report-panel-label'}>
                <div>Total Profit by Destination - Region</div>
                {this.caption(
                  `$ ${formatNumber(this.props.saleProfit
                    .reduce((total, val) => total + parseFloat(val.get('value', 0)), 0), '0,0')}`,
                )
                }
              </Col>
              <Col xs={12}>
                {this.totalProfitChart(this.props.saleProfit.toJS(), true)}
              </Col>
            </Row>
          </Col>
          <Col md={6}>
            <Row className={'report-panel'}>
              <Col xs={12} className={'report-panel-label'}>
                <div>Total Profit by Origin - Region</div>
                {this.caption(
                  `$ ${formatNumber(this.props.purchaseProfit
                    .reduce((total, val) => total + parseFloat(val.get('value', 0)), 0), '0,0')}`,
                )
                }
              </Col>
              <Col xs={12}>
                {this.totalProfitChart(this.props.purchaseProfit.toJS(), false)}
              </Col>
            </Row>
          </Col>
        </Row>
        <Row>
          <Col md={6} id="destinationProfit">
            <Row className={'report-panel'}>
              <Col xs={12} className={'report-panel-label'}>
                <div>Average Per Ton Profit by Destination - Region</div>
              </Col>
              <Col xs={12}>
                {this.avgPerTonProfitChart(this.props.avgPerTonDestination.toJS(), true, true, false)}
              </Col>
            </Row>
          </Col>
          <Col md={6} id="originProfit">
            <Row className={'report-panel'}>
              <Col xs={12} className={'report-panel-label'}>
                <div>Average Per Ton Profit by Origin - Region</div>
              </Col>
              <Col xs={12}>
                {this.avgPerTonProfitChart(this.props.avgPerTonOrigin.toJS(), true, false, false)}
              </Col>
            </Row>
          </Col>
        </Row>
        <Row>
          <Col md={12} className="report-avg-country-pt-profit" id="destinationCountryProfit">
            <Row className={'report-panel'}>
              <Col xs={12} className={'report-panel-label'}>
                <div>Total & Average PMT profit by Destination - Country</div>
              </Col>
              <Col xs={12}>
                {this.destinationProfitChart(
                  this.props.avgCountryPerTonDestination.toJS(), true, true)}
              </Col>
            </Row>
          </Col>
        </Row>
        <Row>
          <Col md={12} className="report-avg-country-pt-profit" id="originCountryProfit">
            <Row className={'report-panel'}>
              <Col xs={12} className={'report-panel-label'}>
                <div>Total & Average PMT profit by Origin - Country</div>
              </Col>
              <Col xs={12}>
                {this.avgPerTonProfitChart(this.props.avgCountryPerTonOrigin.toJS(), true, false,
                  true, reportFormatter2)}
              </Col>
            </Row>
          </Col>
        </Row>
        <Row>
          <Col md={6}>
            <Row className={'report-panel'}>
              <Col xs={12} className={'report-panel-label'}>
                <div>Profitability by product group</div>
                {this.caption(
                  `$ ${formatNumber(this.props.totalSaleProfitProducts
                    .reduce((total, val) =>
                      total + parseFloat(val.get('value', 0)), 0), '0,0')}`,
                )
                }
              </Col>
              <Col xs={12}>
                {this.totalChart(this.props.totalSaleProfitProducts.toJS())}
              </Col>
            </Row>
          </Col>
          <Col md={2} />
        </Row>
      </MainComponentBox>
    );
  }
}

ProfitabilityReportClass.propTypes = {
  purchaseProfit: React.PropTypes.object.isRequired,
  saleProfit: React.PropTypes.object.isRequired,
  avgPerTonOrigin: React.PropTypes.object.isRequired,
  avgPerTonDestination: React.PropTypes.object.isRequired,
  avgCountryPerTonDestination: React.PropTypes.object.isRequired,
  avgCountryPerTonOrigin: React.PropTypes.object.isRequired,
  profitabilityLoad: React.PropTypes.func,
  dateFrom: React.PropTypes.of(Date.class),
  dateTo: React.PropTypes.of(Date.class),
  updateDate: React.PropTypes.func,
  totalProfitByProduct: React.PropTypes.func,
  totalSaleProfitProducts: React.PropTypes.object.isRequired,
};

const ProfitabilityReport = connect(
  state => ({
    purchaseProfit: state.getIn(['data', 'reports', 'profitabilityReport',
      'totalProfitPurchase'], new List()),
    saleProfit: state.getIn(['data', 'reports', 'profitabilityReport',
      'totalProfitSale'], new List()),
    avgPerTonOrigin: state.getIn(['data', 'reports', 'profitabilityReport',
      'avgPerTonOrigin'], new List()),
    avgPerTonDestination: state.getIn(['data', 'reports', 'profitabilityReport',
      'avgPerTonDestination'], new List()),
    avgCountryPerTonDestination: state.getIn(['data', 'reports', 'profitabilityReport',
      'avgCountryPerTonDestination'], new List()),
    avgCountryPerTonOrigin: state.getIn(['data', 'reports', 'profitabilityReport',
      'avgCountryPerTonOrigin'], new List()),
    totalSaleProfitProducts: state.getIn(['data', 'reports', 'profitabilityReport', 'totalSaleProfitProducts'],
      new List()).map((e, idx) => e.set('id', idx + 1)),
    dateFrom: state.getIn(['data', 'reports', 'profitabilityReport', 'dateFrom'], new Date()),
    dateTo: state.getIn(['data', 'reports', 'profitabilityReport', 'dateTo'], new Date()),
  }),
  dispatch => ({
    profitabilityLoad(dateFrom, dateTo) {
      profitabilityLoad(dispatch, dateFrom, dateTo);
    },
    updateDate(dateFrom, dateTo) {
      updateDate(dispatch, dateFrom, dateTo);
    },
    totalProfitByProduct(dealType, dateFrom, dateTo) {
      return totalProfitByProduct(dispatch, dealType, dateFrom, dateTo);
    },
  }),
)(ProfitabilityReportClass);

export default ProfitabilityReport;
